import * as React from 'react'
import * as Styles from './CategoryRecommendLectureModule.style'
import Item from '../../CategoryRecommendLectureItemList/HomeItemListItem'
import {classes} from 'typestyle'
import categoryList from '@/services/categoryIdList'
import {getJsonFromUrl} from '@/utils/tools'

interface CategoryRecommendLectureModuleProps {
    content: any
}

export default class CategoryRecommendLectureModule extends React.Component <CategoryRecommendLectureModuleProps> {
    public render() {
        let renderTitleStyle = {}
        categoryList.map((v) => {
            if (v.id === Number(getJsonFromUrl().id)) {
                switch (v.name) {
                    case '我要变美':
                        return renderTitleStyle = {backgroundImage: 'linear-gradient(-90deg, #FF3657 0%, #FF5A9D 100%)'}
                    case '个人成长':
                        return renderTitleStyle = {backgroundImage: 'linear-gradient(-90deg, #4FB9FF 0%, #52D9F7 100%)'}
                    case '婚姻情感':
                        return renderTitleStyle = {backgroundImage: 'linear-gradient(-90deg, #FC5828 0%, #FDA54C 100%)'}
                    case '亲子教育':
                        return renderTitleStyle = {backgroundImage: 'linear-gradient(-90deg, #467EFF 0%, #50A1FD 99%)'}
                    case '赚钱理财':
                        return renderTitleStyle = {backgroundImage: 'linear-gradient(-90deg, #BAA47E 0%, #E1D59E 100%)'}
                    case '享受生活':
                        return renderTitleStyle = {backgroundImage: 'linear-gradient(-90deg, #40D98C 0%, #71D96A 100%)'}
                    default: {
                        return renderTitleStyle = {}
                    }
                }
            } else {
                return {}
            }
        })
        return (
            <div className={Styles.recommendCategory}>
                <div className={classes(Styles.recommendCategoryTitle)} style={renderTitleStyle}>{this.props.content.official}</div>
                <div className={classes(Styles.recommendCategoryDesc, 'TextChangeToTwoLines')}>{this.props.content.desc}</div>
                <div className={Styles.recommendlectureContentArea}>
                    {this.props.content.contents.map((v: any) => (
                        <Item content={v} key={v.id} bottomMargin={7.5} topMargin={7.5}/>
                    ))}
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/views/Category/components/CategoryRecommendPage/CategoryRecommendLectureModule/CategoryRecommendLectureModule.tsx